import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import { Building2, Coins, Globe2, Plane, Route } from 'lucide-react';

/**
 * Нижняя навигация мира (05 §4).
 *
 * Вкладки будущих фаз показаны и честно помечены номером фазы: пустая вкладка
 * без объяснения - мёртвый элемент, а инвариант 9 требует называть причину.
 */
const TABS = [
  { to: '', key: 'common.nav.hq', Icon: Building2, phase: 0 },
  { to: '/routes', key: 'common.nav.routes', Icon: Route, phase: 3 },
  { to: '/fleet', key: 'common.nav.fleet', Icon: Plane, phase: 3 },
  { to: '/finance', key: 'common.nav.finance', Icon: Coins, phase: 3 },
  { to: '/world', key: 'common.nav.world', Icon: Globe2, phase: 4 },
] as const;

export function TabBar({ worldId }: { worldId: string }) {
  const { t } = useTranslation();
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 flex h-[calc(var(--spacing-tabbar)+env(safe-area-inset-bottom))] items-start border-t border-line bg-ink pb-[env(safe-area-inset-bottom)]">
      {TABS.map(({ to, key, Icon, phase }) => {
        const locked = phase > 0;
        const label = t(key);
        const content = (
          <>
            <Icon size={18} aria-hidden />
            <span className="text-[10px]">{label}</span>
            {locked && (
              <span className="absolute inset-x-0 top-0.5 text-center text-[8px] leading-none text-dim">
                {t('common.phase.locked', { phase })}
              </span>
            )}
          </>
        );
        const cls =
          'relative flex h-[var(--spacing-tabbar)] flex-1 flex-col items-center justify-center gap-1';
        return locked ? (
          <span
            key={key}
            className={`${cls} text-dim opacity-60`}
            title={t('common.phase.lockedReason', { phase })}
            aria-disabled="true"
          >
            {content}
          </span>
        ) : (
          <NavLink
            key={key}
            to={`/w/${worldId}${to}`}
            end
            className={({ isActive }) => `${cls} ${isActive ? 'text-amber' : 'text-mut'}`}
          >
            {content}
          </NavLink>
        );
      })}
    </nav>
  );
}
